import { render, staticRenderFns } from "./CompanyTrainingPortDetail.vue?vue&type=template&id=2f37d621&scoped=true"
import script from "./CompanyTrainingPortDetail.vue?vue&type=script&lang=js"
export * from "./CompanyTrainingPortDetail.vue?vue&type=script&lang=js"
import style0 from "./CompanyTrainingPortDetail.vue?vue&type=style&index=0&id=2f37d621&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f37d621",
  null
  
)

export default component.exports